<template>
    <div class="mHome">
      <pTitle :msg="msg"></pTitle>
      <div class="banner">
        <el-carousel type="card" height="650px" @change="abc">
          <el-carousel-item v-for="item in 3" :key="item" >
            <div class="card_box">
              <div class="card_top">
                <div class="card_title">2024年全国锦标赛</div>
                <div class="card_status">进行中</div>
              </div>
              <div class="xiantiao"></div>
              <div class="card_local">
                <p><i class="el-icon-location-outline"><span>南极体育馆</span></i></p>
                <p><i class="el-icon-time"><span>2024.01.23-2024.03.21</span></i></p>
              </div>
              <div class="card_btm">
                <ul>
                  <li v-for="item in 7" :key="item">男子单打</li>
                  <div></div>
                </ul>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
  
      
    </div>
  </template>
  
  <script>
  import pTitle from "@/components/pTitle.vue";
  import sportList from '@/assets/common/SportList.json';
  import axios from 'axios';
  import http from '@/assets/js/http.js';
  // import lazy from'@/assets/js/element-lazy.js';
  import Vue from "vue";
  import { Lazyload,Toast } from "vant";
  Vue.use(Lazyload,Toast);
  // 注册时可以配置额外的选项
  Vue.use(Lazyload, {
    lazyComponent: true,
  });
  export default {
    name: "mHome",
    components: {
        pTitle,
    },
    data() {
      return {
        msg: "PC端羽毛球成绩网站",
        // images: [
        //   "https://img01.yzcdn.cn/vant/apple-1.jpg",
        //   "https://img01.yzcdn.cn/vant/apple-2.jpg",
        //   "https://img01.yzcdn.cn/vant/apple-3.jpg",
        //   "https://img01.yzcdn.cn/vant/apple-4.jpg",
        // ],
        images: [
        // require("@/assets/img/banner2.jpg"),
            require("@/assets/img/banner1.png"),
            require("@/assets/img/banner2.png"),
            require("@/assets/img/banner7.jpg"),
            // require("@/assets/img/banner0.png"),
        ],
        monthVal: '',
        sportList: {},
        currentPage: 0, // 当前页面的索引值
        pageSize: 3, // 每次加载的数据数量
        listEmpty: [],
        listAllarr: [],
        num: 2,
        dom: null,
        sportListNew:[],
      };
    },
    mounted() {
      http.GetFile('/Sports/BDM/SportList.json?v='+Math.random()).then(res=>{//获取赛事列表地址
          console.log(res)
          this.sportListNew = res.JsonData;
          this.sportList = res;
      })
      
        
    },
    methods: {
      abc(val){
        console.log(val)
      },
      handleGame(item){//点击赛事列表逻辑
        console.log(item);
        
        if(item.StatusCode < 50){
          Toast({
              message:item.StatusName,
              duration:1000
          });
        }else{
          // this.$router.push('/Live');
          // 生成随机数
          let randomNum = Math.random(); // 这里的范围根据需求进行调整
          this.$router.push({
                path: '/GameResult', 
                query: { v: randomNum }
          });
  
          sessionStorage.setItem('SportCode',item.SportCode)
          sessionStorage.setItem('SportName',item.SportName)
        }
      },
      changeMonth(){//月份筛选
        this.sportListNew = this.sportList.JsonData;
        this.monthVal== null ?this.monthVal='': this.monthVal;
        // console.log(this.monthVal);
        let newArr = [];
        let monthVal = this.monthVal
  
        if(monthVal !='' ){
          newArr = this.sportListNew.filter(function(el){
            return el.BeginDate.includes(monthVal)
          })
          console.log(newArr);
          this.sportListNew = newArr;
        }else{
          // console.log()
          this.sportListNew = this.sportList.JsonData;
        }
        // this.activities.forEach(el => {
        //   // console.log(el);
        //   if(el.BeginDate.indexOf(this.monthVal)){
        //     console.log(el)
        //   }
        // });
      },
  
  
      /**
       * 懒加载逻辑-完成
       * */ 
      throttle(fn, wait) {
        // console.log(fn);
        // console.log(wait);
        //闭包节流
        let timer = "";
        return function (...args) {
          if (timer) return;
          timer = setTimeout(() => {
            timer = null;
            fn.apply(this, args);
          }, wait);
        };
      },
      getData(id, lazyLoadObser, lazyImage) {
        // console.log("加载", id);
        // console.log("2", lazyLoadObser);
        // console.log("3载", lazyImage);
        //解绑监听事件
        // console.log(document.getElementsByClassName(id))
        lazyLoadObser.unobserve(lazyImage);
        document.getElementsByClassName(id)[0].style = "transform:translate(0px)";
        //   this.$set(this.activities[id], ".listbox", "b");
      },
      /**
       * 懒加载逻辑结束
       * */
  
  
      /**
       * 懒加载逻辑-写一半方法
       * */
      loadMoreData() {
        this.listAllarr = this.activities;
        this.num = 2;
        this.listEmpty = [];
  
        if (this.listAllarr.length > 2) {
          for (let i = 0; i < 3; i++) {
            this.listEmpty[i] = this.listAllarr[i];
          }
        } else {
          this.listEmpty = this.listAllarr;
        }
      },
      ladzyloding() {
        let dom = document.querySelector(".listWrapper");
  
        console.log(dom.scrollHeight);
        console.log(dom.scrollTop);
        console.log(dom.clientHeight);
        window.addEventListener("scroll", (v) => {
          var pagescrollTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          // console.log(pagescrollTop)
          const scrollDistance =
            dom.scrollHeight - dom.scrollTop - dom.clientHeight;
          console.log("鼠标移动:", scrollDistance);
          if (scrollDistance <= 1) {
            //0等于到底了
            //一条一条加载数据，直至遍历到最后一条
            while (this.num < this.listAllarr.length) {
              this.listEmpty[this.num] = this.listAllarr[this.num];
              // this.listEmpty.push(this.listAllarr[this.num])
              console.log(this.listEmpty);
              this.$forceUpdate();
              this.num++;
              // console.log(this.num)
            }
          }
        });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  $color: #3641C9;
  
  .a {
    transform: translateX(300px);
  }
  .banner {
    width: 1300px;
    // height: 500px;
    // height: 785px;
    margin: 0px auto;
    padding: 0.1rem;
    overflow: hidden;
    // text-align: center;
    img {
      width: 100%;
      height: 3rem;
    }
  }
  .el-carousel__item h3{
    // color: #475669;
    font-size: 14px;
    opacity: 0.75;
    width: 600px;
    // height: 785px;
    border-radius: 10px;
  }
  .el-carousel__item:hover{
    color: white;
    background: $color !important; 
    
  }
  .el-carousel__item{
    // width: 600px;
    background: rgba(255,255,255,0.8) !important;
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.5);
    border-radius: 10px;
  }
  .el-carousel__item:hover .card_title{
    color: white !important;
  }
  .el-carousel__item:hover .xiantiao{
    background: white;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .card_box{
    padding: 10%;
    .card_top{
      text-align: left;
      display: flex;
      justify-content: space-between;
      .card_title{
        font-size: 36px;
        color: #172D79;
        font-weight: bold;
      }
    }
    .xiantiao{
      width: 30%;
      height: 2px;
      background: #333;
      margin-top: 15px;
    }
    .card_local{
      font-size: 30px;
      margin-top: 30px;
      span {
        margin-left: 10px;
      }
    }
    .card_btm{
      width: 100%;
      height: 300px;
      background: white;
      margin-top: 30px;
      border-radius: 10px;
      overflow: hidden;
      color:#333;
      ul{
        overflow: hidden;
        padding: 15px 10%;
        // border-bottom: 2px solid;
        // border-image: radial-gradient(circle,  #172D79,white);
        // border-image-slice: 1;
        li{
          width: 40%;
          float: left;
          padding: 15px;
          list-style: circle;
        }
        div {
          border-bottom: 2px solid;
          border-image: radial-gradient(circle,  #172D79,white);
          border-image-slice: 1;
          width: 100%;
          float: left;
        }
      }
      
    }
  }
  
  // .el-carousel__item 
  </style>